import { render } from "./BottomNavigationItem.vue?vue&type=template&id=2df4b336&scoped=true"
import script from "./BottomNavigationItem.vue?vue&type=script&lang=ts"
export * from "./BottomNavigationItem.vue?vue&type=script&lang=ts"

import "./BottomNavigationItem.vue?vue&type=style&index=0&id=2df4b336&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2df4b336"

export default script